export type AvatarColor = 'informative' | 'warning' | 'brand' | 'teal' | 'pink' | 'success'

export const AVATAR_COLORS: readonly AvatarColor[] = [
  'informative',
  'warning',
  'brand',
  'teal',
  'pink',
  'success',
]

/** The first letter of the first word, so "Neerh Deka" is "N". */
export function avatarInitial(name: string): string {
  const [first = ''] = Array.from(name.trim())
  return first.toLocaleUpperCase()
}

/** A stable colour per name, so one person looks the same wherever their avatar appears. */
export function avatarColor(name: string): AvatarColor {
  let hash = 0
  for (const char of name.trim().toLowerCase()) {
    hash = (Math.imul(hash, 31) + (char.codePointAt(0) ?? 0)) | 0
  }
  const count = AVATAR_COLORS.length
  return AVATAR_COLORS[((hash % count) + count) % count]
}
